import { Endpoints } from '@/api/ApiEndpoints';

import router from '@/router';
import { Paths } from '@/core/config/enums/SitePaths';
import { Inputs,validationSchema } from '@/entities/Countries/CountriesFormInputs'

const Countries = {
	Plural: 'Countries',
	Single: 'Country',
	IsPage: true,
	FormWithImage: true,
	Inputs: Inputs,
	Relationships: [
		{
			name: 'leagueIds',
			endpoint: Endpoints.LEAGUES_FOR_FILTERS,
			mapping: (response) => {
				return response;
			},
			dataMapping: (response) => {

				response.forEach(element => {
					
					element['name'] = element.country.name + " - " + element.name
				});

				return response;
			},
		},
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		router.push(Paths.COUNTRIES_EDIT.replace(':id', String(id)))
	}
};

export default Countries;
